<template>
  <Teleport to="body">
    <div class="fixed bottom-6 inset-x-0 z-[200] flex justify-center pointer-events-none px-4">
      <Transition name="toast-up">
        <div
          v-if="visible"
          class="pointer-events-auto flex items-center gap-3 px-4 py-3 bg-gray-900 dark:bg-[#1C2128] rounded-2xl shadow-2xl border border-white/10"
          style="max-width: min(24rem, 100%)"
        >
          <div
            class="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center"
            :class="type === 'notice' ? 'bg-green-500' : 'bg-red-500'"
          >
            <svg v-if="type === 'notice'" class="w-3.5 h-3.5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3">
              <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
            </svg>
            <svg v-else class="w-3.5 h-3.5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>

          <p class="text-sm font-medium text-white leading-snug">{{ message }}</p>

          <button
            @click="dismiss"
            class="flex-shrink-0 ml-1 text-white/50 hover:text-white/90 transition-colors focus:outline-none"
            aria-label="Dismiss"
          >
            <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </Transition>
    </div>
  </Teleport>
</template>

<script setup>
import { ref } from 'vue'

const message = ref('')
const type = ref('notice')
const visible = ref(false)

let timer = null

function show(msg, msgType) {
  message.value = msg
  type.value = msgType || 'notice'
  visible.value = true
  clearTimeout(timer)
  timer = setTimeout(dismiss, 3500)
}

function dismiss() {
  visible.value = false
  clearTimeout(timer)
}

defineExpose({ show })
</script>

<style scoped>
.toast-up-enter-from {
  opacity: 0;
  transform: translateY(0.75rem);
}
.toast-up-enter-to {
  opacity: 1;
  transform: translateY(0);
}
.toast-up-enter-active {
  transition: opacity 0.2s ease, transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
}
.toast-up-leave-active {
  transition: opacity 0.18s ease, transform 0.2s ease;
}
.toast-up-leave-to {
  opacity: 0;
  transform: translateY(0.5rem);
}
</style>
